<template>
  <div class="edie-wrap">
    <!-- 用户信息 -->
    <div class="title">
      <h2 class="pull-left">{{userModelLan.userInfo}}</h2>
      <div class="btn-back pull-right">
        <button class="btn btn-info" @click="hanldeBack">{{userModelLan.btnBack}}</button>
      </div>
      <div class="clear"></div>
    </div>
    <div class="section row">
      <!-- 登录账号 -->
      <input-model 
        :label="userModelLan.loginId" :placeholder="userModelLan.pleaseEnter" 
        :errTips="userModelLan.errTips" :data="login" :modelKey="'login'"
        :ref="'login'" :validateRule="'required|max:20'" :disabled="true"
        @changeData="handleChangeData" >
      </input-model>
      <!-- 用户名称 -->
      <input-model 
        :label="userModelLan.loginName" :placeholder="userModelLan.pleaseEnter" 
        :errTips="userModelLan.errTips" :data="name" :modelKey="'name'"
        :ref="'name'" :validateRule="'required|max:50'" :disabled="false"
        @changeData="handleChangeData" >
      </input-model>
      <!-- 用户密码 -->
      <input-model 
        :label="userModelLan.userPwd" :placeholder="userModelLan.pleaseEnter" 
        :errTips="userModelLan.errTips" :data="password" :modelKey="'password'"
        :ref="'password'" :validateRule="{required: false}" :disabled="false" :inputType="'password'"
        @changeData="handleChangeData" >
      </input-model>
      <!-- 是否启用 -->
      <input-model 
        :label="userModelLan.isEnable" :placeholder="userModelLan.pleaseSelect" 
        :errTips="userModelLan.errTips" :data="enable" :modelKey="'enable'"
        :ref="'enable'" :validateRule="''" :disabled="false" :inputType="'radio'"
        :radioYes="userModelLan.yes" :radioNo="userModelLan.no"
        @changeData="handleChangeData" >
      </input-model>
      <!-- 设置角色 -->
      <div class="col-xs-12 col-lg-8">
        <div class="form-group">
          <label>{{userModelLan.setRole}}</label>
          <el-transfer v-model="value" :data="tData" :titles="transferTitles" v-validate="'required'" name="setRole"></el-transfer>
          <div class="err-tips" v-show="errors.has('setRole')">{{userModelLan.pleaseSelect}}</div>
        </div>
      </div>
    </div>
    <div class="footer">
      <!-- 保存 -->
      <button class="btn btn-primary" @click="saveFn">{{userModelLan.saveBtn}}</button>
    </div>
    <modal v-model="showModal" title="Modal Title" :header="false" :footer="false" size="sm" @hide="handleModalHide">
      <p class="successful-modal" v-show="showSuccessfulModal"><i class="fa fa-check" aria-hidden="true"></i>{{modalTips}}</p>
      <p class="failed-modal" v-show="!showSuccessfulModal"><i class="fa fa-times" aria-hidden="true"></i>{{modalTips}}</p>
    </modal>
  </div>
</template>

<script>
import { URL_ROLELIST,URL_USER } from 'api/api.js'
import { Modal } from 'uiv'
import inputModel from 'components/inputModel'
export default {
  mixins: [require("common/mixin/base.js").base({userModelLan:"userModel"})],
  components: {
    inputModel,
    Modal
  },
  data() {
    return {
      login: '', 
      name: '', 
      password: '', 
      enable: '', 
      tData: [], // 穿梭框左边数据
      value: [], // 穿梭框右边数据
      responseData: {}, // 后台返回的数据
      showModal: false, // 是否显示模态窗
      modalTips: '',
      showSuccessfulModal: false,
      responseRoleList: [],
    }
  },
  created() {
    this.getData()
  },
  computed: {
    selectedRole() { // 已经选中的角色
      let roleList = this.responseRoleList.map(v => v.roleId)
      let arr = []
      this.value.forEach(i => {
        i<roleList.length && i >=0 && arr.push(roleList[i])
      })
      return arr
    },
    transferTitles(){ // 穿梭框标题头
      return [this.userModelLan.existingRoleList, this.userModelLan.selectedRoleList]
    },
    requestData() { // 请求时数据
      let roleIdList = []
      for(let item of this.responseData.role){
        roleIdList.push(item.roleId) 
      }
      let obj = {}
      obj.login = this.responseData.login
      if(this.name !== this.responseData.name) obj.name = this.name
      else delete obj.name
      if(this.password !== '') obj.password = this.password
      else delete obj.password
      if(this.enable !== this.responseData.enable) obj.enable = this.enable
      else delete obj.enable
      if(this.selectedRole.sort().toString() !== roleIdList.sort().toString()) obj.role = this.selectedRole
      else delete obj.role
      return obj
    }
  },
  methods: {
    getData() { // 获取数据
      let p1 = this.$http.get(URL_ROLELIST+'/?type=simplify') // 获取角色列表
      let p2 = this.$http.get(URL_USER+'/'+this.$route.query.login) // 获取某个用户信息
      Promise.all([p1,p2]).then( res => {
        this.responseRoleList = res[0].data.data
        for(let i = 0; i< this.responseRoleList.length; i++) {
          this.tData.push({key: i, label: this.responseRoleList[i].name})
        }
        let data = res[1].data.data
        this.responseData = res[1].data.data
        this.login = data.login
        this.name = data.name
        this.enable = data.enable

        let map = {}
        this.tData.forEach(obj => map[obj.label] = obj.key)
        data.role.forEach(role => this.value.push(map[role.name]))
      } )
    },
    hanldeBack() { // 处理返回的操作
      let url = '/userMaintenance?pageIndex='+this.$route.query.pageIndex+'&seekKey='+this.$route.query.seekKey+'&seekVal='+this.$route.query.seekVal
      this.$router.push(url)
    },
    handleChangeData(val,modelKey) { // 处理子组件绑定的数据
      this[modelKey] = val
    },
    validateAll(success) { // 验证全部
      let p1 = this.$refs.login.$validator.validate()
      let p2 = this.$refs.name.$validator.validate()
      let p3 = this.$refs.password.$validator.validate()
      let p4 = this.$refs.enable.$validator.validate()
      let p5 = this.$validator.validate()
      Promise.all([p1,p2,p3,p4,p5]).then(res => {
        if(!res.every(v => v)) {
          this.showModal = true
          this.showSuccessfulModal = false
          this.modalTips = this.userModelLan.errTips
        }else if(Object.keys(this.requestData).length <= 1) {
          this.showModal = true
          this.showSuccessfulModal = false
          this.modalTips = this.userModelLan.noEdit
        }else success()
      })
    },
    saveFn() { // 保存
      this.validateAll( () => {
        this.$http.put(URL_USER,this.requestData).then(res => {
          if(res.data.code === 200 && res.data.data === 'success'){
            this.showModal = true
            this.showSuccessfulModal = true
            this.modalTips = this.userModelLan.success
          }else alert(res.data.msg)
        }).catch(e => alert(e))
      })
    },
    handleModalHide() { // 处理弹窗隐藏
      if(this.showSuccessfulModal) this.$router.push('/userMaintenance')
    }
  }
}
</script>


<style lang="scss" scoped>
.edie-wrap{
  margin: 0 20px;
  padding: 20px;
  background-color: #fff;
  border: 1px solid #ddd;
  .title{
    border-bottom: 1px solid #e5e5e5;
    margin-bottom: 20px;
    h2{
      line-height: 55px;
      font-size: 24px;
      font-weight: 700;
    }
    .btn-back{
      line-height: 55px;
    }
  }
  .section{
    .form-group{
      padding-bottom: 20px;
      margin-bottom: 10px;
      position: relative;
      .err-tips{
        position: absolute;
        bottom: 0;
        left: 0;
        color: red;
      }
    }
  }
  .footer{
    margin: 20px 0;
    text-align: center;
    .btn{
      padding: 8px 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/userMaintenance/userEdit.vue